/*
 * HLTH subscription minimum: the drawer's two fixes
 *
 * The drawer (snippets/cart-drawer.liquid) works out from the cart whether the subscribed
 * bags of the minimum product are short of the minimum. When they are, it disables the
 * checkout button and shows a notice with two buttons; this file handles those buttons:
 *   [data-submin-add]    sets that subscribed line to the quantity that meets the minimum
 *   [data-submin-oneoff] moves that line to a one-time purchase (selling_plan: null)
 * Both redraw the drawer from the same /cart/change.js call. The checkout-press backstop
 * lives in hlth-free-shaker.js.
 *
 * Since 1.9.1 (21 Oct 2026) the notice is snippets/hlth-submin-notice.liquid, counted per
 * delivery, and the cart page shows it too; a fix pressed there reloads the cart page.
 */
(function () {
  if (!window.HLTH_SUB_MIN) return;

  const SOURCE = 'hlth-subscription-minimum';

  function sectionIds() {
    const drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map((s) => s.id)
      : [];
  }

  async function change(body, button) {
    const inDrawer = !!button.closest('cart-drawer');
    const ids = inDrawer ? sectionIds() : [];
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }
    button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('/cart/change.js ' + res.status);
      const data = await res.json();
      if (!inDrawer) {
        window.location.reload();
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') drawer.renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: data });
      }
    } catch (err) {
      console.error('[hlth-subscription-minimum]', err);
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const add = event.target.closest && event.target.closest('[data-submin-add]');
    if (add) {
      event.preventDefault();
      change({ id: add.dataset.key, quantity: Number(add.dataset.qty) }, add);
      return;
    }
    const oneoff = event.target.closest && event.target.closest('[data-submin-oneoff]');
    if (oneoff) {
      event.preventDefault();
      change({ id: oneoff.dataset.key, quantity: Number(oneoff.dataset.qty), selling_plan: null }, oneoff);
    }
  });
})();
